/* ==========================================================================
   AURORA STUDIO — the sale
   One object (window.AURORA_SALE, printed by theme.liquid from theme
   settings) drives everything below:

     presale  → until presaleEnds. Countdown targets the presale end.
                Licences are delivered on the launch date.
     earlybird→ from presaleEnds on. The site flips at that exact second
                without a reload: <html> swaps au-presale for au-earlybird,
                every [data-p] span follows, the countdown re-targets the
                real early bird deadline, and the markers turn ember.

   Nothing here rewrites text with regexes. Every phase-dependent line is
   written twice in the HTML and CSS shows the one that applies.
   ========================================================================== */
(function () {
  'use strict';
  var S = window.AURORA_SALE || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  var test = /[?&]ebtest=1/.test(window.location.search);

  var presaleTs = new Date(S.presaleEnds || '').getTime();
  var saleTs    = new Date(S.saleEnds || '').getTime();
  var price = S.price || 149, list = S.list || 499;

  /* ---------------------------------------------------------- prices */
  $$('[data-price]').forEach(function (el) { el.textContent = '$' + price; });
  $$('[data-price-v1]').forEach(function (el) { el.textContent = '$' + list; });
  $$('[data-price-save]').forEach(function (el) { el.textContent = '$' + (list - price); });

  /* ----------------------------------------------------------- phase */
  function isEarlyBird() { return test || (!isNaN(presaleTs) && Date.now() >= presaleTs); }
  var html = document.documentElement;
  function applyPhase() {
    var eb = isEarlyBird();
    if (eb && !html.classList.contains('au-earlybird')) {
      html.classList.remove('au-presale'); html.classList.add('au-earlybird');
    } else if (!eb && !html.classList.contains('au-presale')) {
      html.classList.remove('au-earlybird'); html.classList.add('au-presale');
    }
    return eb;
  }

  /* ------------------------------------------------------- countdown */
  /* presale: count to the presale end. early bird: count to the real
     sale end. If that has passed too, hide the digits — a timer that
     restarts is the fastest way to lose an ad account. */
  function target(eb) {
    if (!eb) return presaleTs;
    if (!isNaN(saleTs) && Date.now() < saleTs) return saleTs;
    return NaN;
  }
  var cd = $('#auCountdown');
  var cdEls = cd ? { d: $('[data-cd="d"]', cd), h: $('[data-cd="h"]', cd), m: $('[data-cd="m"]', cd), s: $('[data-cd="s"]', cd) } : null;

  function split(ms) {
    if (ms < 0) ms = 0;
    return { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
  }

  function tick() {
    var eb = applyPhase();
    var t = target(eb);
    var over = isNaN(t);
    var r = split(over ? 0 : t - Date.now());

    if (cd) {
      cd.classList.toggle('is-over', over);
      if (cdEls.d) cdEls.d.textContent = pad(r.d);
      if (cdEls.h) cdEls.h.textContent = pad(r.h);
      if (cdEls.m) cdEls.m.textContent = pad(r.m);
      if (cdEls.s) cdEls.s.textContent = pad(r.s);
    }

  }
  tick();
  setInterval(tick, 1000);

  /* ----------------------------------------------------- allocation bar */
  var spotsEl = $('[data-spots]');
  if (spotsEl) {
    var total = parseInt(spotsEl.getAttribute('data-total'), 10) || 100;
    var reserved = parseInt(spotsEl.getAttribute('data-reserved'), 10) || 0;
    var countEl = $('[data-spots-count]', spotsEl);
    var fillEl = $('[data-spots-fill]', spotsEl);
    var pct = Math.min(100, reserved / total * 100);
    var run = function () {
      if (fillEl) fillEl.style.width = pct + '%';
      if (!countEl) return;
      if (reduced) { countEl.textContent = reserved; return; }
      var t0 = null, dur = 1600;
      var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
      var step = function (ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        countEl.textContent = Math.round(ease(p) * reserved);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } }); }, { threshold: 0.4 });
      io.observe(spotsEl);
    } else { run(); }
  }

})();
